import React, { Component } from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import uuidv4 from 'uuid/v4';
import { GET_CURRENT_USER_CLIENT } from '@joybird/joystagram-components/dist/esm/queries';
import { detect } from 'detect-browser';
import { isClient } from '../../../../../app/globals';

const withTracking = ComposedComponent => {
  class Container extends Component {
    componentDidMount() {
      this.log('variant-tracker');
    }

    getUTCDateTime = () => {
      const tsUTC = new Date();
      return (
        tsUTC.getUTCFullYear() +
        '-' +
        ('0' + (tsUTC.getUTCMonth() + 1)).slice(-2) +
        '-' +
        ('0' + tsUTC.getUTCDate()).slice(-2) +
        ' ' +
        ('0' + tsUTC.getUTCHours()).slice(-2) +
        ':' +
        ('0' + tsUTC.getUTCMinutes()).slice(-2) +
        ':' +
        ('0' + tsUTC.getUTCSeconds()).slice(-2)
      );
    };

    async log(type, data, action = 'VARIANT_TRACKER') {
      if (isClient()) {
        const browser = detect() || {};
        let loggedInUser = {};
        const loggedInUserResp = await this.props.client.query({
          query: GET_CURRENT_USER_CLIENT,
        });

        if (!loggedInUserResp.error) {
          if (loggedInUserResp.data && loggedInUserResp.data.user) {
            //A user is logged in
            loggedInUser = loggedInUserResp.data.user;
          } else {
            //Retrieve temp user stored in cache
            // const tempUserResp = await this.props.client.query({
            //   query: GET_TEMP_USER_CLIENT,
            // });
            // if (!tempUserResp.error) {
            //   loggedInUser = tempUserResp.data.temp_user;
            // }
          }
        }

        const currentTimestamp = this.getUTCDateTime();
        let browserData = {
          name: browser.name || '',
          version: browser.version || '',
          os: browser.os || '',
        };
        const payload = {
          event_id: uuidv4(),
          type: type,
          action: action,
          user: loggedInUser,
          browser: browserData,
          trigger: 'AWARE',
          route: {
            url: this.props.match.url,
            match: this.props.match,
            location: this.props.location,
          },
          variant: {
            id: this.props.variant?.id,
          },
          timestamp: currentTimestamp,
        };
        try {
          // Do nothing. This used to call Sherlock but as of July 2022 has
          // been non-functional for around 2 years. We should either remove
          // this or just output to the dev console instead.
        } catch (e) {
          console.log('Error occurred in sherlock', e);
        }
      }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }
  return withApollo(Container);
};

export default withTracking;
